import axios from 'axios';

const state = {
  interactions: [],
  currentInteraction: null,
  loading: false,
  error: null
}

const mutations = {
  SET_INTERACTIONS(state, interactions) {
    state.interactions = interactions
  },
  SET_CURRENT_INTERACTION(state, interaction) {
    state.currentInteraction = interaction
  },
  ADD_INTERACTION(state, interaction) {
    state.interactions.push(interaction)
  },
  UPDATE_INTERACTION(state, updatedInteraction) {
    const index = state.interactions.findIndex(interaction => interaction.id === updatedInteraction.id)
    if (index !== -1) {
      state.interactions.splice(index, 1, updatedInteraction)
    }
    if (state.currentInteraction && state.currentInteraction.id === updatedInteraction.id) {
      state.currentInteraction = updatedInteraction
    }
  },
  REMOVE_INTERACTION(state, interactionId) {
    state.interactions = state.interactions.filter(interaction => interaction.id !== interactionId)
    if (state.currentInteraction && state.currentInteraction.id === interactionId) {
      state.currentInteraction = null
    }
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  async fetchInteractions({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/api/interactions')
      commit('SET_INTERACTIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Erro ao buscar interações')
      console.error('[Interactions] Erro ao buscar interações:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async fetchInteractionsForLead({ commit }, leadId) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get(`/api/leads/${leadId}/interactions`)
      commit('SET_INTERACTIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Erro ao buscar interações do lead')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async fetchInteraction({ commit }, interactionId) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get(`/api/interactions/${interactionId}`)
      commit('SET_CURRENT_INTERACTION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Erro ao buscar interação')
      console.error(`[Interactions] Erro ao buscar interação ${interactionId}:`, error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async createInteraction({ commit }, interactionData) {
    commit('SET_LOADING', true)
    try {
      // Verificar e garantir que o lead_id é um número
      if (interactionData.lead_id && typeof interactionData.lead_id !== 'number') {
        console.log('[Interactions] Convertendo lead_id para número:', interactionData.lead_id);
        interactionData = {
          ...interactionData,
          lead_id: parseInt(interactionData.lead_id, 10)
        };
      }
      
      console.log('[Interactions] Enviando requisição de criação com dados:', interactionData);
      const response = await axios.post('/api/interactions', interactionData)
      console.log('[Interactions] Interação criada com sucesso:', response.data);
      commit('ADD_INTERACTION', response.data)
      return response.data
    } catch (error) {
      console.error('[Interactions] Erro ao criar interação:', error);
      console.error('[Interactions] Detalhes da requisição:', interactionData);
      if (error.response) {
        console.error('[Interactions] Status:', error.response.status);
        console.error('[Interactions] Dados de erro:', error.response.data);
      }
      commit('SET_ERROR', error.message || 'Erro ao criar interação')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async updateInteraction({ commit }, { id, data }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.put(`/api/interactions/${id}`, data)
      commit('UPDATE_INTERACTION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Erro ao atualizar interação')
      console.error(`[Interactions] Erro ao atualizar interação ${id}:`, error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async deleteInteraction({ commit }, interactionId) {
    commit('SET_LOADING', true)
    try {
      await axios.delete(`/api/interactions/${interactionId}`)
      commit('REMOVE_INTERACTION', interactionId)
      return true
    } catch (error) {
      commit('SET_ERROR', error.message || 'Erro ao excluir interação')
      console.error(`[Interactions] Erro ao excluir interação ${interactionId}:`, error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async getInteractionsRequiringFollowup({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/api/interactions/requiring-followup')
      commit('SET_INTERACTIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Erro ao buscar interações pendentes')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  allInteractions: state => state.interactions,
  interactionById: state => id => state.interactions.find(interaction => interaction.id === id),
  interactionsByLead: state => leadId => state.interactions.filter(interaction => interaction.lead_id === leadId),
  interactionsByType: state => type => state.interactions.filter(interaction => interaction.tipo === type),
  recentInteractions: state => {
    return [...state.interactions]
      .sort((a, b) => new Date(b.data_hora) - new Date(a.data_hora))
      .slice(0, 5)
  },
  upcomingInteractions: state => {
    const now = new Date()
    return [...state.interactions]
      .filter(interaction => new Date(interaction.data_hora) > now)
      .sort((a, b) => new Date(a.data_hora) - new Date(b.data_hora))
      .slice(0, 5)
  },
  currentInteraction: state => state.currentInteraction,
  isLoading: state => state.loading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 